import _ from 'lodash'
import { compression, obj, dt, num, str, swal } from '@/util'

// Mixin
export const standardMixin = {
	// Data
	data: () => ({
		breakForMobile: false,
		size: {},
		// Methods
		_,
		compression,
		obj,
		dt,
		num,
		str,
		swal
	}),
	// Get Vars
	computed: {
		params() {
			let urlSearchParams = new URLSearchParams(window.location.search);
			return Object.fromEntries(urlSearchParams.entries()) || {};
		}
	},
	methods: {
		// Resize Events
		detectScreenSize() {
			this.size = {
				isSm: (window.innerWidth >= 768 && window.innerWidth < 992),
				isSmUp: (window.innerWidth >= 768),
				isSmDown: (window.innerWidth < 768),
				isMd: (window.innerWidth >= 992 && window.innerWidth < 1280),
				isMdUp: (window.innerWidth >= 992),
				isMdDown: (window.innerWidth < 992),
				isLg: (window.innerWidth >= 1280 && window.innerWidth < 1600),
				isLgUp: (window.innerWidth >= 1280),
				isLgDown: (window.innerWidth < 1280),
				isXl: (window.innerWidth >= 1600),
				isXlDown: (window.innerWidth < 1600),
			};
			this.breakForMobile = this.size.isLgDown;
		},
		sleep(ms) {
			return new Promise(resolve => setTimeout(resolve, ms));
		}
	},
	created() {
		this.detectScreenSize();
		window.addEventListener("resize", this.detectScreenSize);
	},
	unmounted() {
		window.removeEventListener("resize", this.detectScreenSize);
	}
}